import { z } from "zod";

export const videoSubtitleCacheEntrySchema = z.union([
  z.object({
    fileUploadedAt: z.string().nullable(),
    srtVersion: z.string(),
    content: z.string(),
  }),
  z.object({
    fileUploadedAt: z.string().nullable(),
    srtVersion: z.null(),
    content: z.null(),
  }),
]);
export type VideoSubtitleCacheEntry = z.infer<
  typeof videoSubtitleCacheEntrySchema
>;

export function getVideoSubtitleVersion(video: {
  srtGcsPath: string | null;
  srtUpdatedAt?: Date | null;
  srtEditedAt?: Date | null;
}): string | null {
  if (!video.srtGcsPath) {
    return null;
  }

  return (video.srtUpdatedAt ?? video.srtEditedAt)?.toISOString() ?? "original";
}
